/*** IMPORTS FROM imports-loader ***/
var define = false;

// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var idCounter = 0;
export default function uniqueId(prefix) {
  var id = ++idCounter + '';
  return prefix ? prefix + id : id;
}




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/uniqueId.js
// module id = 195
// module chunks = 0